import { useMemo, useState } from 'react';
import styles from './index.module.less';
import VaryDataItem from '../varous-data-item';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';
import OurModal from '@/components/Modal';

const Index = ({ platListItem }: { platListItem: any }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>({});

  const labelList = useMemo(() => {
    return platListItem.features.map((item: any) => item.name);
  }, [platListItem]);

  return (
    <ul className={styles.container}>
      <li>
        {labelList.map((item: string, index: number) => (
          <div key={index}>
            <span>{capitalizeFirstLetter(t(item))}</span>
          </div>
        ))}
      </li>

      <div className={styles.content}>
        <VaryDataItem
          platformData={platListItem.features}
          getRow={(row: any) => {
            setIsModalOpen(true);
            setModalData(row);
          }}
        />
      </div>
      <OurModal isModalOpen={isModalOpen} handleCancel={() => setIsModalOpen(false)}>
        <div style={{ paddingTop: '10px' }}>
          <div>{modalData.value}</div>
          <div style={{ color: '#8a8a8a' }}>{modalData.detail}</div>
        </div>
      </OurModal>
    </ul>
  );
};

export default Index;
